import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import Seo from "../components/Seo";
import Logo from "../components/Logo";
import { trackPhoneClick } from "../lib/analytics";

export default function NotFound() {
    return (
        <div className="grain relative flex min-h-screen flex-col overflow-hidden bg-navy font-sans text-white">
            <Seo
                title="Page Not Found | Hexagon EOR"
                description="The page you are looking for could not be found. Return to the Hexagon EOR homepage or contact our team."
                path="/404"
            />
            <div className="dot-grid absolute inset-0" aria-hidden="true" />
            <header className="relative mx-auto flex w-full max-w-7xl px-5 py-6 sm:px-8">
                <Link to="/" aria-label="Hexagon EOR home" data-testid="not-found-home-logo">
                    <Logo dark />
                </Link>
            </header>
            <main
                data-testid="not-found-page"
                className="relative flex flex-1 flex-col items-center justify-center px-5 pb-24 text-center"
            >
                <p className="font-display text-7xl font-extrabold tracking-tighter text-gold sm:text-8xl">
                    404
                </p>
                <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">
                    This page could not be found
                </h1>
                <p className="mt-4 max-w-md text-base leading-relaxed text-white/65">
                    The link may be outdated or the page may have moved. Head
                    back to the homepage, or call our team if you were looking
                    for something specific.
                </p>
                <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                    <Link
                        to="/"
                        data-testid="not-found-home-cta"
                        className="inline-flex items-center rounded-full bg-gold px-7 py-4 font-display text-sm font-extrabold uppercase tracking-wider text-navy transition-[background-color,transform] duration-200 hover:bg-[#b8985a] hover:scale-[1.03]"
                    >
                        Back to Homepage
                    </Link>
                    <a
                        href="tel:+18333439367"
                        data-testid="not-found-call-cta"
                        onClick={() => trackPhoneClick("404")}
                        className="inline-flex items-center gap-2.5 rounded-full border border-white/25 px-7 py-4 font-display text-sm font-bold uppercase tracking-wider text-white transition-[background-color,border-color] duration-200 hover:border-white/50 hover:bg-white/5"
                    >
                        <Phone size={16} aria-hidden="true" />
                        +1 833-343-9367
                    </a>
                </div>
            </main>
        </div>
    );
}
